import {
  faDownload,
  faExclamationTriangle,
  faFilter,
  faChevronLeft,
  faChevronDown, faPlay, faPause, faHandPaper, faLaptop,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Collapsible from "react-collapsible";
import React from "react";
import {
  ButtonGroup,
  Col,
  Row,
  ToggleButton,
  Badge,
  Card,
} from "react-bootstrap";
import {
  selectFilter,
  textFilter,
  dateFilter,
} from "react-bootstrap-table2-filter";
import { withTranslation } from "react-i18next";
import PaginationTable from "../../../components/paginationTable/PaginationTable";
import APIErrorHelper from "../../../helpers/APIErrorHelper";
import InstanceStatus from "../../../helpers/InstanceStatus";
import CamplaCoreService from "../../../services/CamplaCoreService";
import ExaminationInstanceStatusCell from "../../singleExamination/tabs/instancesTab/examInstanceStatusCell/ExaminationInstanceStatusCell";
import ExaminationInstanceSubmissionCell from "../../singleExamination/tabs/instancesTab/examInstanceSubmissionCell/ExaminationInstanceSubmissionCell";
import ExaminationInstanceIndicatorCell from "../../singleExamination/tabs/instancesTab/examInstanceIndicatorCell/ExaminationInstanceIndicatorCell";
import ExamInstanceActionCellAuditors from "../examInstanceActionCellAuditors/ExamInstanceActionCellAuditors";
import ExaminationInfoCardAuditor from "../examinationInfoCardAuditor/ExaminationInfoCardAuditor";
import PaginationTableFilterToggle from "../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";
import DateTimeHelper from "../../../helpers/DateTimeHelper";

class AuditorCard extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "instancesAuditorTabTable";
    this.state = {
      dialogApiError: "",
      apiError: "",
      showFilters: true,
      displayFilter: "initial",
    };

    this.onExamFileDownloadReset = this.onExamFileDownloadReset.bind(this);
    this.onSEBSessionQuit = this.onSEBSessionQuit.bind(this);
  }

  async onSEBSessionQuit(instance) {
    try {
      await CamplaCoreService.quitSEBSession(instance._id);
    }catch(err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
            err,
            () => this.setState({dialogApiError: ""}),
            {},
            this.props.t,
        ),
      });
    }
  }

  async onExamFileDownloadReset(instance) {
    try {
      await CamplaCoreService.resetExamFileDownload(instance._id);
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleExamination.InstanceTab.APIError.PreconditionFailed",
            NOT_FOUND: "SingleExamination.InstanceTab.APIError.NotFound",
            BAD_REQUEST: "SingleExamination.InstanceTab.BadRequest",
          },
          this.props.t,
        ),
      });
    }
  }

  render() {
    const { t } = this.props;
    const actionCellData = {
      examinationStatus: this.props.examination?.status,
    };
    const currentTableId =
      typeof this.props["examination"] !== "undefined" &&
      this.props["examination"] !== null &&
      typeof this.props.examination["_id"] !== "undefined"
        ? `${this.tableId}-${this.props.examination?._id}`
        : this.tableId;
    const columns = [
      {
        dataField: "hasStarted",
        text: "",
        sort: true,
        headerStyle: () => ({ width: "40px" }),
        formatter: (hasStarted, instance) => (<FontAwesomeIcon
            icon={faDownload}
            title={hasStarted ? DateTimeHelper.formatDate(instance.attendedAt) : ""}
            className={hasStarted ? "color-green" : "color-black"}
        />)
      },
      {
        dataField: "memberDeviceHealth",
        text: "",
        headerStyle: () => ({ width: "85px" }),
        headerFormatter: () => <FontAwesomeIcon icon={faLaptop} />,
        formatExtraData: actionCellData,
        formatter: (hasStarted, instance) => (
          <ExaminationInstanceIndicatorCell
            onHasNotes={() => {}}
            instance={instance}
            examination={this.props.examination}
            id={instance._id}
          />
        ),
        sort: false,
      },
      {
        dataField: "memberName",
        text: t("SingleExamination.InstanceTab.ColumnMemberName"),
        sort: true,
        filter: textFilter({
          placeholder: t(
              "SingleExamination.InstanceTab.FilterMemberNamePlaceholder",
          ),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "lastFileChange",
        text: t("SingleExamination.InstanceTab.ColumnLastSubmission"),
        sort: true,
        filter: dateFilter({
          placeholder: t(
            "SingleExamination.InstanceTab.FilterLastSubmissionPlaceholder",
          ),
          style: { display: this.state.displayFilter },
        }),
        formatter: (lastFileChange, instance) => (
          <ExaminationInstanceSubmissionCell
            submission={
              typeof instance["lastSubmission"] === "undefined"
                ? null
                : instance.lastSubmission
            }
            instance={instance}
          />
        ),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatExtraData: actionCellData,
        formatter: (cell, row, idx, props) => (
          <ExamInstanceActionCellAuditors
            onExamFileDownloadReset={() => this.onExamFileDownloadReset(row)}
            onSEBSessionQuit={() => this.onSEBSessionQuit(row)}
            examinationStatus={props.examinationStatus}
            examination={this.props.examination}
            instance={row}
          />
        ),
      },
    ];


    const registeredDevices = this.props.examination.instances.filter(i => i.memberDeviceHealth).length
    const runningExamination = this.props.examination.instances
        .filter(i => i.memberDeviceHealth && i._id === i.memberDeviceHealth.instanceId).length;
    const pausedDevices = registeredDevices - runningExamination;

    const memberDeviceHealth = this.props.examination
    && registeredDevices > 0
    && (this.props.examination.status === 11 || (this.props.examination.status >= 30 && this.props.examination.status <= 32))
        ? (<Badge className="badge-light ml-3" style={{fontSize: 14}}>
          <FontAwesomeIcon icon={faPlay} className="color-green" /> {runningExamination} / <FontAwesomeIcon icon={faPause} className="color-black" /> {pausedDevices}
        </Badge>) : "";

    const invalidDeviceInstances = this.props.examination.instances.filter(
        (i) => i.memberDevice !== null && i.memberDevice.status === 40,
    ).length;
    const invalidDevices =
        (this.props.examination.securityLevel === 3 ||
            this.props.examination.securityLevel === 4) &&
        invalidDeviceInstances > 0 ? (
            <Badge className="badge-light ml-3" style={{fontSize: 14}}>
              <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
              {invalidDeviceInstances} / {this.props.examination.instances.length}
            </Badge>
        ) : (
            ""
        );
    const raisedHandsCount = this.props.examination.instances
        .filter(i => typeof i["memberDeviceHealth"] !== "undefined"
            && i["memberDeviceHealth"] !== null
            && typeof i["memberDeviceHealth"]["raisedHand"] !== "undefined"
            && i.memberDeviceHealth.raisedHand).length;
    const raisedHands = raisedHandsCount > 0
          && (this.props.examination.status === 1 || this.props.examination.status === 11 || (this.props.examination.status >= 30 && this.props.examination.status <= 32))
        ? (
        <Badge className="badge bg-color-yellow color-black ml-3" style={{fontSize: 14}}>
          <FontAwesomeIcon icon={faHandPaper} /> {raisedHandsCount}
        </Badge>
    ) : "";

    return (
      <div>
        <Row className="mb-2" key={this.props.examination?._id}>
          <Col>
            <Card>
              <Card.Body className="examCardBody">
                <Collapsible
                  overflowWhenOpen="visible"
                  open={this.props.count === 0}
                  trigger={
                    <Card.Title>
                      {this.props.examination?.name}
                      <FontAwesomeIcon
                        icon={faChevronLeft}
                        style={{ float: "right" }}
                      />
                    </Card.Title>
                  }
                  triggerWhenOpen={
                    <Card.Title>
                      {this.props.examination?.name}
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        style={{ float: "right" }}
                      />
                    </Card.Title>
                  }
                >
                  <Row className="my-4">
                    <Col>
                      <ExaminationInfoCardAuditor
                        t={this.props.t}
                        tReady={() => {}}
                        examination={this.props.examination}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-2">
                      <h6>
                        <Badge className="badge-light" style={{fontSize: 14}}>
                          <FontAwesomeIcon icon={faDownload} className="color-green" />{" "}
                          {// eslint-disable-next-line
                            this.props.examination.instances
                                .filter((i) => i.hasStarted)
                                .reduce((accu) => accu + 1, 0)}{" "}
                          / {this.props.examination.instances.length}
                        </Badge>
                        {raisedHands}
                        {invalidDevices}
                        {memberDeviceHealth}
                      </h6>
                    </Col>
                  </Row>
                  <Row className="mt-1 pb-3">
                    <Col>
                      <PaginationTable
                        data={this.props.examination.instances}
                        sizePerPage={this.props.examination.instances.length}
                        paginationSize={3}
                        columns={columns}
                        keyField="_id"
                        id={currentTableId}
                        noFilterCache={true}
                      />
                    </Col>
                  </Row>
                </Collapsible>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(AuditorCard);
